export const common = {
  nav: {
    ourFleet: 'Our Rentals',
    destinations: 'Destinations',
    experiences: 'Experiences',
    contact: 'Contact',
    bookNow: 'Book Now'
  },
  common: {
    backHome: 'Back to rentals',
    backToFleet: 'Back to rentals'
  },
  hero: {
    badge: 'French Riviera Adventure',
    title1: 'Explore the',
    title2: 'French Riviera',
    description: 'Character rentals for an unforgettable Mediterranean experience. Boats, iconic cars, camper vans, motorcycles and an exceptional house — explore the Riviera your way.',
    subtitle: 'Boats • Iconic Cars • Camper Vans • Motorcycles • House',
    discover: 'Discover',
    catBoats: 'Boats',
    catBoatsDesc: 'Explore the calanques and golden islands from Hyères. With or without skipper.',
    catBoatsPrice: 'From €490/day',
    catCars: 'Cars',
    catCarsDesc: 'Mustang, Jeep, Porsche — icons for legendary roads.',
    catCarsPrice: 'From €190/day',
    catCampers: 'Camper Vans',
    catCampersDesc: 'Total freedom between Provence and the Mediterranean.',
    catCampersPrice: 'From €149/day',
    fullyInsured: 'Fully Insured',
    personalService: 'Personal Service',
    basedHyeres: 'Based in Hyères, French Riviera'
  },
  boats: {
    homePort: 'Home Port: Hyères',
    title: 'Our',
    titleHighlight: 'Boats',
    description: 'Two exceptional motorboats based in Hyères for your perfect French Riviera adventure',
    upTo: 'Up to',
    guests: 'guests',
    passengers: 'passengers',
    berths: 'berths',
    skipperIncluded: 'Skipper Included',
    avgFuel: 'Avg. fuel consumption',
    featuresIncluded: 'Features included',
    startingFrom: 'Starting from',
    perDay: 'per day',
    skipperRequired: 'Skipper required',
    withOrWithout: 'With or without skipper',
    bookThisBoat: 'Book This Boat'
  },
  fleet: {
    badge: 'Character Rentals — French Riviera',
    title: 'Our',
    titleHighlight: 'Rentals',
    description: 'More than just vehicles — a handpicked selection chosen for character, style and the emotions they inspire. Sea, road, mountain or stay: explore the French Riviera your way.',
    selectCategory: 'Click a category to discover what\'s available',
    startingFrom: 'Starting from',
    tabBoats: 'Boats',
    tabCars: 'Cars',
    tabCampers: 'Camper Vans',
    tabMotorcycles: 'Motorcycles',
    tabHouses: 'House',
    tabBoatsDesc: 'Explore the calanques and golden islands from Hyères',
    tabCarsDesc: 'Mustang, Jeep, Porsche — icons on the roads of the Riviera',
    tabCampersDesc: 'Total freedom between Provence and the Mediterranean',
    tabMotorcyclesDesc: 'Harley, Ducati, BMW — the road is your playground',
    tabHousesDesc: 'An exceptional villa with private pool and sea views in Hyères',
    tabBoatsPrice: 'From €490/day',
    tabCarsPrice: 'From €220/day',
    tabCampersPrice: 'From €159/day',
    tabMotorcyclesPrice: 'From €129/day',
    tabHousesPrice: 'From €590/night'
  },
  cars: {
    seats: 'seats',
    places: 'seats',
    doors: 'doors',
    fuelType: 'Fuel',
    featuresIncluded: 'Features included',
    startingFrom: 'Starting from',
    perDay: 'per day',
    kmIncluded: 'Mileage included',
    bookThisCar: 'Book This Car'
  },
  motorcycles: {
    seats: 'seats',
    fuelType: 'Fuel',
    featuresIncluded: 'Features included',
    startingFrom: 'Starting from',
    perDay: 'per day',
    kmIncluded: 'Mileage included',
    bookThisMotorcycle: 'Book This Motorcycle'
  },
  campers: {
    seats: 'seats',
    berths: 'berths',
    fuelType: 'Fuel',
    featuresIncluded: 'Features included',
    startingFrom: 'Starting from',
    perDay: 'per day',
    kmIncluded: 'Mileage included',
    bookThisCamper: 'Book This Camper'
  },
  houses: {
    upTo: 'Up to',
    guests: 'guests',
    bedrooms: 'bedrooms',
    bathrooms: 'bathrooms',
    startingFrom: 'Starting from',
    perDay: 'per night',
    bookThisHouse: 'Book This House'
  },
  destinations: {
    title: 'Your',
    titleHighlight: 'Playground',
    description: 'From Hyères to Monaco, the French Riviera is yours to explore — by boat, convertible or motorcycle. Every road, every cove is a new adventure.'
  },
  experiences: {
    title: 'Live the',
    titleHighlight: 'Adventure',
    description: 'Every rental is an invitation to explore the Mediterranean your way — sea, road or mountain.',
    bookThis: 'Book This Experience'
  },
  trust: {
    title: 'The',
    titleHighlight: 'HOPLA Spirit',
    description: 'Not a classic rental company. A lifestyle brand that hands you the keys to the Riviera.',
    fullyInsured: 'Fully Insured',
    fullyInsuredDesc: 'All our vehicles come with comprehensive insurance. Leave worry behind and focus on the adventure.',
    personalService: 'Personalised Experience',
    personalServiceDesc: 'We\'re not a big chain. Every client is unique — we tailor each rental to your desires and your style.',
    wellMaintained: 'Character Vehicles',
    wellMaintainedDesc: 'Mustang, Harley, motorboats — our vehicles are chosen for their soul, their style and the emotions they deliver. Meticulously maintained.',
    localExpertise: 'Local Know-How',
    localExpertiseDesc: 'We know every cove, every mountain pass, every scenic road. Our insider tips turn your stay into a true Mediterranean adventure.',
    secretLocations: 'Secret calanques and scenic roads',
    bestSnorkeling: 'Best snorkelling spots and campsites',
    recommendedItineraries: 'Tailor-made road trip itineraries',
    flexibleOptions: 'Total Freedom',
    flexibleOptionsDesc: 'With or without skipper, short or long-term, sea or road — you choose your adventure, we handle the rest.',
    skipperAvailable: 'Skipper available on request',
    halfOrFull: 'Short or long-term rental',
    customItineraries: 'Custom itineraries possible',
    premiumVehicles: 'Character Vehicles',
    happyGuests: 'Happy Adventurers',
    averageRating: 'Average Rating'
  },
  contact: {
    title: 'Book Your',
    titleHighlight: 'Adventure',
    description: 'Ready to explore the French Riviera? Select your preferred date and time, and we\'ll confirm your booking within 24 hours.',
    callUs: 'Call Us',
    whatsapp: 'WhatsApp',
    email: 'Email',
    homePort: 'Home Port',
    homePortValue: 'Hyères, French Riviera'
  },
  faq: {
    title: 'Frequently Asked',
    titleHighlight: 'Questions',
    description: 'Everything you need to know before setting off on your French Riviera adventure',
    q1: 'Do I need a boating licence to rent your boats?',
    a1: 'For CARLA (Bayliner 3055 Ciera), a valid boating licence is required if you want to rent without a skipper. You can also choose to have a skipper for a worry-free experience. For MAMILIPP III (Astondoa 49 GL), a professional skipper is always included.',
    q2: 'What is included in the rental price?',
    a2: 'All rentals include the vehicle and comprehensive insurance. Boats include fuel and snorkelling gear. Cars and motorcycles include unlimited mileage. Camper vans include a full travel kit.',
    q3: 'What types of rentals do you offer?',
    a3: 'We offer 5 categories of character rentals: motorboats (Bayliner and Astondoa), iconic cars (Mustang, Jeep, Jaguar, Range Rover, Porsche), exceptional motorcycles (Harley-Davidson, Ducati, BMW GS), fully equipped camper vans and an exceptional villa with pool and sea views. All based on the French Riviera.',
    q4: 'Do I need a special licence to rent a motorcycle?',
    a4: 'Yes, a valid category A licence (or A2 depending on engine size) is required. The Harley-Davidson Sportster S and BMW R 1250 GS require a full A licence. The Ducati Monster 937 may be accessible with an A2 licence depending on your experience.',
    q5: 'What happens in case of bad weather?',
    a5: 'Safety is our priority. For boat trips, if weather conditions are unsuitable, we\'ll contact you to reschedule at no extra cost. Car, motorcycle and camper van rentals are generally not affected by weather.',
    q6: 'Can you recommend an itinerary?',
    a6: 'That\'s our speciality! By boat: Porquerolles and Port-Cros from Hyères. By Mustang or Porsche: the Corniche de l\'Esterel and Saint-Tropez. By motorcycle: the Gorges du Verdon and Col de Vence. By camper van: the Provence-Riviera loop. We\'ll customise it to your taste!'
  },
  footer: {
    description: 'A Mediterranean adventure brand. Boats, iconic cars, motorcycles, camper vans and an exceptional house to explore the French Riviera in total freedom — based in Hyères, Côte d\'Azur.',
    quickLinks: 'Quick Links',
    reviews: 'Reviews',
    destinationsTitle: 'Destinations',
    contactUs: 'Contact Us',
    copyright: '© 2025 HOPLA FRENCH RIVIERA. All rights reserved.',
    ourServices: 'Our Rentals',
    boatRental: 'Boat Rental',
    carRental: 'Iconic Cars',
    camperRental: 'Camper Vans & Freedom'
  },
  calendar: {
    stepSelectDate: 'Select Date',
    stepSelectTime: 'Select Time',
    stepReviewSubmit: 'Confirm',
    selectDateTitle: 'Choose Your Preferred Date',
    selectTimeTitle: 'Select Available Time Slot',
    reviewTitle: 'Review & Confirm Your Booking',
    availableSlots: 'Available time slots',
    noSlotsAvailable: 'No time slots available for this date',
    selectedDate: 'Selected Date',
    selectedTime: 'Selected Time',
    modifyTime: 'Change',
    customerName: 'Your Name',
    customerPhone: 'Phone Number',
    preferredBoat: 'Preferred Vehicle',
    numberOfGuests: 'Number of Guests',
    specialRequests: 'Special Requests',
    back: 'Back',
    next: 'Next',
    confirmBooking: 'Confirm Booking',
    bookingSuccess: 'Booking Confirmed!',
    bookingSuccessMessage: 'We will contact you shortly to confirm the details of your rental.',
    bookingError: 'Something went wrong. Please try again or contact us directly.',
    newBooking: 'Make Another Booking',
    loading: 'Loading available dates...',
    bookingDetails: 'Booking Details',
    selectBoat: 'Select a vehicle',
    boatCarla: 'CARLA - Bayliner 3055 Ciera (up to 8 guests)',
    boatMamilipp: 'MAMILIPP III - Astondoa 49 GL (up to 12 guests)',
    selectGuests: 'Select number of guests',
    guests12: '1-2 guests',
    guests34: '3-4 guests',
    guests56: '5-6 guests',
    guests78: '7-8 guests',
    guests910: '9-10 guests',
    guests1112: '11-12 guests',
    placeholder: 'Any special requests or questions...',
    monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    dayNames: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  },
  inspirations: {
    calanquesTitle: 'Calanques & Golden Islands by Boat',
    calanquesDesc: 'Set off from Hyères to discover wild calanques and the island of Porquerolles. Swim in crystal-clear coves unreachable by road — the adventure starts here.',
    sunsetTitle: 'Mustang Road Trip on the Corniche',
    sunsetDesc: 'Top down, Mediterranean sunset ahead. The Corniche de l\'Esterel in a Mustang GT is one of the world\'s most beautiful drives. An experience that stays with you forever.',
    islandTitle: 'Grand Motorcycle Tour: Verdon & Riviera',
    islandDesc: 'Alpine gorges in the morning, coastline in the afternoon. On a Harley or BMW GS, this circuit blends mountain scenery and Mediterranean coast for an unforgettable road trip.',
    fullDay: 'Full Day',
    evening: 'Half Day'
  },
  destNames: {
    calanques: 'Calanques de Marseille',
    calanquesDesc: 'Stunning limestone cliffs and turquoise coves',
    cassis: 'Cassis',
    cassisDesc: 'Charming fishing village with colorful harbor',
    frioul: 'Îles de Frioul',
    frioulDesc: 'Pristine islands with secluded beaches',
    saintTropez: 'Saint-Tropez',
    saintTropezDesc: 'Glamorous port and legendary beaches',
    cannes: 'Cannes',
    cannesDesc: 'Famous Croisette and beautiful bay',
    nice: 'Nice & Villefranche',
    niceDesc: 'Azure waters and Belle Époque charm',
    mustSee: 'Must See',
    popular: 'Popular',
    hiddenGem: 'Hidden Gem',
    iconic: 'Iconic',
    classic: 'Classic',
    beautiful: 'Beautiful'
  }
};
